<!-- Content -->
<div class="content container-fluid mt-1">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'courseModule.createCourse' | translate }}
      </h1>
    </div>
  </header>
  <!-- End Page Header -->

  <course-form-general
    [course]="course$ | async"
    [showSubmitButton]="false"
    (onSubmit)="onSubmitGeneralForm($event)"
  ></course-form-general>

  <div class="d-flex my-5 justify-content-end create-position-sticky">
    <button
      data-test-id="course-details-create-course-button"
      type="button"
      class="btn btn-primary"
      (click)="onClickCreate()"
    >
      {{ 'general.create' | translate }}
    </button>
  </div>
</div>
